export function comparePortions(adanovaCents, adanovaServings, otherPrice, otherServings) {
  if (![adanovaCents, adanovaServings, otherPrice, otherServings].every(n => Number.isFinite(n) && n > 0)) return null;
  const adanova = Math.round(adanovaCents / adanovaServings);
  const other = Math.round(otherPrice * 100 / otherServings);
  if (![adanova, other].every(Number.isSafeInteger)) return null;
  return { adanova, other, difference: adanova - other };
}

function initComparisons(scope) {
  scope.querySelectorAll('[data-portion-comparison]').forEach(root => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('form');
    const price = form.querySelector('[data-comparison-price]');
    const servings = form.querySelector('[data-comparison-servings]');
    const output = root.querySelector('[data-comparison-output]');
    const result = root.querySelector('[data-comparison-result]');
    const error = root.querySelector('[data-comparison-error]');
    const currency = root.dataset.currency || 'MXN';
    const money = cents => `${new Intl.NumberFormat('es-MX', { style: 'currency', currency, currencyDisplay: 'narrowSymbol' }).format(cents / 100)} ${currency}`;

    function update() {
      const fields = [price, servings];
      fields.forEach(field => field.setAttribute('aria-invalid', String(field.value !== '' && !field.validity.valid)));
      const invalid = fields.some(field => field.value !== '' && !field.validity.valid);
      const comparison = !invalid && comparePortions(Number(root.dataset.price), Number(root.dataset.servings), price.valueAsNumber, servings.valueAsNumber);
      output.textContent = comparison ? money(comparison.other) : 'Sin calcular';
      error.textContent = invalid ? 'Revisa el precio y las porciones: deben ser mayores que cero y estar dentro del límite.' : '';
      if (!comparison) {
        result.textContent = '';
        return;
      }
      result.textContent = comparison.difference === 0
        ? 'Mismo costo por porción, redondeado a centavos.'
        : `Adanova cuesta ${money(Math.abs(comparison.difference))} ${comparison.difference > 0 ? 'más' : 'menos'} por porción.`;
    }
    form.addEventListener('input', update);
    form.addEventListener('submit', event => { event.preventDefault(); form.reportValidity(); update(); });
    form.addEventListener('reset', event => {
      event.preventDefault();
      price.value = '';
      servings.value = '';
      update();
    });
    root.hidden = false;
    update();
  });
}

if (typeof document !== 'undefined') {
  initComparisons(document);
  document.addEventListener('shopify:section:load', event => initComparisons(event.target));
}
